<template>
    <div class="box">
        <van-icon name="checked" color="rgb(7,193,96)" size="40"/>
        <div>提交成功</div>
        <div>感谢您的反馈</div>
    </div>
</template>


<style lang="scss" scoped>
    .box{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top:3.125rem;
        flex-direction: column;
    }
    .box div{
        margin-top: .9375rem;
        line-height: 1.125rem;
        font-size: 1.125rem;
    }
</style>